module.exports = __webpack_public_path__ + "static/media/flutter-kicks.40c54c89.mp4";